/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import React from "react";
import "./TextInputField.scss";
import { ControlError, ControlHelper, Input, Label } from "@forge/common";

/**
 * Text input field
 * @returns input entered
 */
interface IProps {
  fieldLabel?: string;
  id: string;
  type: string;
  required?: boolean;
  placeholder?: string;
  onChange?: (value: string) => void;
  error?: boolean;
  helperText?: string;
  value?: any;
  disabled?: boolean;
  labelFontSize?: string;
  marginBottom?: string;
  dataTestId?: string;
  styleName?: string;
  className?: string;
}

const TextInputField = (props: IProps) => {
  return (
    <>
      <Label>
        {props.fieldLabel} {props.required ? "*" : ""}
      </Label>
      <Input
        disabled={props.disabled}
        className={props.className}
        error={props.error}
        id={props.id}
        value={props.value}
        type={props.type}
        placeholder={props.placeholder}
        onChange={(e: any) => {
          const value = e.target.value;
          if (value.length > 31 && props.id.toLowerCase().includes("name")) {
            e.target.value = value.slice(0, 31); // Truncate the value to 5 characters
          }
          props.onChange && props.onChange(e.target.value);
        }}
        data-testid={props.dataTestId}
      />
      {props.error && (
        <ControlError className="control-error">
          {props.helperText}
        </ControlError>
      )}
    </>
  );
};

export default TextInputField;
